import { Injectable } from '@angular/core';
import { BaseAPI } from '@core/services/base-api.service';
import { Mapper } from '@core/services/base-mapper.service';
import { APIConstants } from '@shared/constants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IFleetSurveyPayload } from '@shared-features/interfaces/fleet-survey-payload.interface';

@Injectable({
  providedIn: 'root',
})
export class FleetSurveyService {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  addFleetSurvey(fleetSurvey: IFleetSurveyPayload): Observable<void> {
    return this.baseAPI.post(APIConstants.API_ADD_FLEET_SURVEY, fleetSurvey);
  }
}
